<template>
  <div>
    <Flicking
      :options="{
        align: align,
        circular: true,
        autoResize: true,
        bound: false,
        gap: 10,
        moveType: 'freeScroll',
        animationDuration: 0,
        stopOnHover: true,
        duration: 500,
        scale: 1,
      }"
      :plugins="plugins"
    >
      <div class="mx-1" v-for="item in securities" :key="item.id">
        <div @click="goToSecurityPage(item)" class="main-div">
          <picture class="image-sec d-flex justify-center align-center">
            <v-img v-if="item.logo" class="sec-img" :src="item.logo"></v-img>
            <v-img
              class="sec-img"
              style="opacity: 60%"
              v-else
              :src="noImage_logo"
            >
            </v-img>
          </picture>
          <div class="stocks">{{ item.symbol }}</div>
          <div class="number">{{ item.live_price.toFixed(2) }}</div>
          <div
            :class="item.up_down_percent >= 0 ? 'percentage' : 'min-percentage'"
          >
            {{ item.up_down_percent }}%
          </div>
        </div>
      </div>
      <span
        slot="viewport"
        class="flicking-arrow-prev is-thin is-circle"
      ></span>
      <span
        slot="viewport"
        class="flicking-arrow-next is-thin is-circle"
      ></span>
    </Flicking>
  </div>
</template>

<script>
import newAxios from "@/api/newAxios";

import { Fade, AutoPlay, Arrow } from "@egjs/flicking-plugins";

export default {
  data() {
    return {
      show: true,
      plugins: [new Fade(), new AutoPlay(0, 0, "NEXT", true), new Arrow()],
      security_img: require("@/assets/images/facebook.svg"),
      noImage_logo: require("@/assets/images/No-img-logo.svg"),
      // Customizing align position
      securities: [],
      align: {
        camera: "50%",
        panel: "50%",
      },
    };
  },

  methods: {
    goToSecurityPage(item) {
      this.$router.push({
        name: "Search",
        params: { query: `${item.name}-${item.exchange}` },
        query: { tab: 0 },
      });
    },
    getStockList() {
      const onSuccess = (res) => {
        // console.log(res);
        this.securities = res.data.securities;
      };
      const onFailure = () => {};
      newAxios("get", "trending/securities/", {
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },
  },

  mounted() {
    this.getStockList();
  },
};
</script>

<style lang="scss" scoped>
.flicking-arrow-prev.is-circle,
.flicking-arrow-next.is-circle {
  background-color: white !important;
  border-radius: 50% !important;
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flicking-arrow-prev::before,
.flicking-arrow-next::before {
  background-color: grey;
  height: 3px !important;
  width: 14px !important;
  content: "";
  display: block !important;
  position: absolute;
  transform-origin: 100% 50%;
  transform: rotate(-45deg);
  right: 22px;
}
.flicking-arrow-prev::after,
.flicking-arrow-next::after {
  background-color: grey;
  height: 3px !important;
  width: 14px !important;
  content: "" !important;
  display: block !important;
  position: absolute !important;
}
.flicking-arrow-prev::after {
  margin-left: -12px !important;
  transform-origin: 100% 50%;
  transform: rotate(135deg);
  right: 22px;
}
.flicking-arrow-prev::before {
  margin-left: -12px !important;
  transform-origin: 100% 50%;
  transform: rotate(-135deg);
  right: 22px;
}
.flicking-arrow-next::after {
  transform-origin: 100% 50%;
  transform: rotate(45deg);
  right: 22px;
  margin-right: -12px !important;
  position: absolute;
  height: 3px !important;
  width: 14px !important;
  display: block !important;
  position: absolute;
}
.flicking-arrow-next::before {
  transform-origin: 100% 50%;
  transform: rotate(-45deg);
  right: 22px;
  margin-right: -12px !important;
  top: 50% !important;
  right: 22px !important;
  transform-origin: 100% 50%;
}
.flicking-arrow-prev.is-circle::before,
.flicking-arrow-next.is-circle::before {
  position: absolute !important;
  background-color: grey;
  height: 3px !important;
  width: 14px !important;
  display: block !important;
}
.flicking-arrow-next {
  position: absolute;
  top: 50% !important;
  cursor: pointer !important;
  transform: translateY(-50%) !important;
  z-index: 2;
  right: 10px !important;
}
.flicking-arrow-prev {
  position: absolute !important;
  top: 50% !important;
  cursor: pointer !important;
  transform: translateY(-50%) !important;
  z-index: 2 !important;
  right: 10px !important;
  left: 10px !important;
}
.flicking-arrow-prev.is-thin::after,
.flicking-arrow-next.is-thin::after {
  top: calc(50% - -1px);
}
@media only screen and (max-width: 768px) {
  .main-div {
    width: 130px !important;
    height: 118px !important;
    margin-top: 20px !important;
  }
  .stocks {
    font-size: 15px !important;
  }
  .number,
  .percentage,
  .min-percentage {
    font-size: 13px !important;
    margin-top: 5px !important;
  }
  .image-sec {
    left: 43px !important;
  }
  .sec-img {
    width: 29px !important;
    height: 29px !important;
  }
  .min-percentage {
  }
}
// @import url("node_modules/@egjs/vue-flicking/dist/flicking.css");
// Or, if you have to support IE9
// @import url("node_modules/@egjs/vue-flicking/dist/flicking-inline.css");
.image-sec {
  position: absolute;
  // width: 52px;
  // height: 52px;
  border: 0.5px solid #e4e4e4;
  border-radius: 12px;
  padding: 8px;
  top: -25px;
  left: 55px;
  background: #ffffff;
}
.min-percentage {
  margin-top: 10px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: center;
  color: red;
}
.sec-img {
  // border-radius: 12px;
  // padding: 20px;
  // border: 0.5px solid #e4e4e4;
  width: 35px;
  height: 35px;
}
.main-div {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  width: 166px;
  height: 150px;
  border: 1px solid #e4e4e4;
  background: #ffffff;
  margin-top: 25px;
  border-radius: 20px;
  cursor: pointer;
}
.stocks {
  margin-top: 30px;
  font-family: Avenir;
  font-size: 18px;
  font-weight: 800;
  line-height: 24.59px;
  text-align: center;
  color: #333333cc;
}
.number,
.percentage {
  margin-top: 10px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: center;
}
.percentage {
  color: #27ae60;
}
</style>
